import React from 'react';
import PropTypes from 'prop-types';
import PageFooter from '../PageFooter/PageFooter';
import PagesHeader from '../Headers/PagesHeader';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import PageHeaderWrapper from '../PageHeader/PageHeaderWrapper';

const PageLayout = ({
  children,
  pageTitle,
  breadcrumbLinks = null,
  shouldIncludeDashboard = false,
  shouldShowBreadcrumbs = true,
  shouldShowPageHeader = false,
  pageHeaderOrganizationId = null,
}) => {
  return (
    <div className="min-h-screen flex flex-col justify-between">
      {/* PageHeader renders at full width at the top */}
      {shouldShowPageHeader && <PageHeaderWrapper organizationId={pageHeaderOrganizationId} />}

      {/* Main content area with left margin */}
      <div className="ml-8.75 flex-grow">
        <header>
          <div className="gap-y-7.5 mb-4">
            {/* Breadcrumbs are shown only on Download page.
                On unregistered user pages (email_verifications), breadcrumbs are disabled by default. */}
            {shouldShowBreadcrumbs && breadcrumbLinks && (
              <Breadcrumbs
                links={breadcrumbLinks}
                className="mt-20"
                shouldIncludeDashboard={shouldIncludeDashboard}
              />
            )}
            <div className={`py-2.5 pl-2 ${!shouldShowBreadcrumbs || !breadcrumbLinks ? 'mt-20' : ''}`}>
              <PagesHeader label={pageTitle} size="h-10" />
            </div>
          </div>
        </header>
        {children}
      </div>

      {/* PageFooter renders at full width at the bottom */}
      <PageFooter />
    </div>
  );
};

PageLayout.propTypes = {
  children: PropTypes.node.isRequired,
  pageTitle: PropTypes.string.isRequired,
  breadcrumbLinks: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ),
  shouldIncludeDashboard: PropTypes.bool,
  shouldShowBreadcrumbs: PropTypes.bool,
  shouldShowPageHeader: PropTypes.bool,
  pageHeaderOrganizationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default PageLayout;
